import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withValue } from '@g4/automation-hooks';

import { useTranslations } from './../graphql/components/TranslationsProvider';
import { Button, Box, Spinner, useMedia } from './Boneyard';

const propTypes = {
  loading: PropTypes.bool,
  automationHook: PropTypes.string,
  isDisabled: PropTypes.bool,
  onSubmit: PropTypes.func,
};

const defaultProps = {
  automationHook: 'page-footer',
};

export const ContinueButtonTag = styled(Button)`
  width: 100%;
  min-width: 160px;
  height: 50px;

  ${props => props.theme.query.md} {
    width: auto;
    min-width: 250px;
  }
`;

const ContinueButton = ({ loading, onSubmit, automationHook, isDisabled }) => {
  const translations = useTranslations();
  const continueButtonLabel = translations?.common?.continueButtonLabel;

  const mq = useMedia();

  return (
    <Box d="flex" justifyContent="flex-end" position="relative">
      <ContinueButtonTag
        disabled={isDisabled || loading}
        htmlType={onSubmit ? 'submit' : undefined}
        onClick={onSubmit}
        automationHook={withValue(automationHook, 'continue')}
        fullWidth={mq.lte('sm')}
      >
        {loading ? (
          <Spinner
            size="xsmall"
            appearance="light"
            automationHook={withValue(automationHook, 'spinner')}
          />
        ) : (
          continueButtonLabel
        )}
      </ContinueButtonTag>
    </Box>
  );
};

ContinueButton.propTypes = propTypes;
ContinueButton.defaultProps = defaultProps;

export default ContinueButton;
